module.exports = __webpack_public_path__ + "img/deer-8157052_1280.e94730ac.png";